"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["classes", "title", "buttons", "contentText", "onClose", "onConfirm", "buttonType", "disableConfirm"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    button: {
      margin: theme.spacing(1)
    },
    textField: {
      marginTop: '1rem',
      fontSize: 12
    },
    dialogPaper: {
      minWidth: '20rem',
      minHeight: '20rem'
    }
  };
};
function createMarkup(text) {
  return {
    __html: text
  };
}
var ConfirmWithInput = /*#__PURE__*/function (_Component) {
  function ConfirmWithInput() {
    (0, _classCallCheck2["default"])(this, ConfirmWithInput);
    return _callSuper(this, ConfirmWithInput, arguments);
  }
  (0, _inherits2["default"])(ConfirmWithInput, _Component);
  return (0, _createClass2["default"])(ConfirmWithInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        title = _this$props.title,
        buttons = _this$props.buttons,
        contentText = _this$props.contentText,
        onClose = _this$props.onClose,
        onConfirm = _this$props.onConfirm,
        buttonType = _this$props.buttonType,
        disableConfirm = _this$props.disableConfirm,
        other = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);

      //MOVING THE CREATION OF csvdata TO THE API EVENTUALLY
      //let csvdata = createSurveySummary(survey);
      //console.log('DW csvdata is: ', csvdata);

      var cancelText = this.props.cancelText ? this.props.cancelText : 'Cancel';
      var confirmText = this.props.confirmText ? this.props.confirmText : 'Confirm';
      delete other.cancelText;
      delete other.confirmText;
      return /*#__PURE__*/_react["default"].createElement(_material.Dialog, (0, _extends2["default"])({
        classes: {
          paper: classes.dialogPaper
        },
        onClose: onClose,
        "aria-labelledby": "simple-dialog-title"
      }, other), /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
        id: "simple-dialog-title"
      }, title), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, {
        dangerouslySetInnerHTML: createMarkup(contentText)
      }), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, buttons !== 'confirm-only' && /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return onClose();
        }
      }, cancelText), /*#__PURE__*/_react["default"].createElement(_material.Button, {
        type: buttonType,
        disabled: disableConfirm,
        form: "theForm",
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return onConfirm();
        }
      }, confirmText)));
    }
  }]);
}(_react.Component);
ConfirmWithInput.propTypes = {
  title: _propTypes["default"].string.isRequired,
  onClose: _propTypes["default"].func,
  onConfirm: _propTypes["default"].func.isRequired,
  contentText: _propTypes["default"].string.isRequired,
  cancelText: _propTypes["default"].string
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(ConfirmWithInput);